import React from "react";

const filterReservedRecords = (records, selectedPalletsUI) => {
	return records.filter((pallet) => !!selectedPalletsUI[pallet.id]);
};

export const usePickingListRecords = ({
	isSelectedViewMode,
	isReservationMode,
	selectedPalletsUI,
	data,
	ids,
}) => {
	const [records, setRecords] = React.useState([]);
	const [viewRecords, setViewRecords] = React.useState([]);

	React.useEffect(() => {
		if (!data || !ids?.length) {
			setRecords([]);
			return;
		}
		// data can lag ids for a render on filter change; drop holes so consumers never see undefined records
		setRecords(ids.map((id) => data[id]).filter(Boolean));
	}, [data, ids]);

	React.useEffect(() => {
		if (isSelectedViewMode) {
			if (isReservationMode) {
				setViewRecords(filterReservedRecords(records, selectedPalletsUI));
			}
			return;
		}
		setViewRecords(records);
	}, [records, isSelectedViewMode, isReservationMode, selectedPalletsUI]);

	// Update records when a pallet is selected or unselected to dynamically adjust
	// available/reserved quantities and weights (whole-pallet reservation).
	const updateRecordsOnPalletSelection = React.useCallback((palletId, isSelect) => {
		setRecords((prevRecords) =>
			prevRecords.map((record) => {
				if (record.id !== palletId) return record;
				if (isSelect) {
					return {
						...record,
						available_quantity: 0,
						available_weight: 0,
						reserved_quantity: record.quantity,
						reserved_weight: record.net_weight,
					};
				}
				return {
					...record,
					available_quantity: record.quantity,
					available_weight: record.net_weight,
					reserved_quantity: 0,
					reserved_weight: 0,
				};
			})
		);
	}, []);

	return {
		records,
		viewRecords,
		updateRecordsOnPalletSelection,
	};
};
